//TODO https://auctane.atlassian.net/browse/PRO-417
let UpsellInsuranceType = /*#__PURE__*/function (UpsellInsuranceType) {
  UpsellInsuranceType["PACKLINK_INSURANCE"] = "PACKLINK_INSURANCE";
  UpsellInsuranceType["NO_INSURANCE"] = "NO_INSURANCE";
  UpsellInsuranceType["STANDARD"] = "STANDARD";
  UpsellInsuranceType["PROOF_OF_DELIVERY"] = "PROOF_OF_DELIVERY";
  UpsellInsuranceType["ENHANCED"] = "ENHANCED";
  return UpsellInsuranceType;
}({});
let GTMEvents = /*#__PURE__*/function (GTMEvents) {
  GTMEvents["PAGE_META_DATA"] = "pageMetaData";
  GTMEvents["VIRTUAL_PAGE_VIEW"] = "virtualPageView";
  GTMEvents["BUTTON_CLICK"] = "buttonClick";
  GTMEvents["APPLY_COUPON"] = "applyCoupon";
  GTMEvents["SIGN_IN"] = "sign-in";
  GTMEvents["SIGN_UP"] = "sign-up";
  GTMEvents["LOGOUT"] = "logout";
  GTMEvents["OWN_CONTRACT"] = "ownContract";
  GTMEvents["OWN_CONTRACT_FORM"] = "ownContractForm";
  GTMEvents["CONTACT_FORM"] = "contact";
  GTMEvents["SEARCH"] = "search";
  GTMEvents["SHIPPING_SEARCH"] = "shippingSearch";
  GTMEvents["TENANTPLACE_INTEGRATION"] = "tenantplaceIntegration";
  GTMEvents["EECOMMERCE"] = "EEcommerce";
  GTMEvents["CONFIRM_PURCHASE"] = "confirmPurchase";
  GTMEvents["CORE_WEB_VITALS"] = "coreWebVitals";
  GTMEvents["MARKETPLACE_INTEGRATION"] = "marketplaceIntegration";
  GTMEvents["UPGRADE_ACCOUNT"] = "upgradeAccount";
  return GTMEvents;
}({});
let GTMCustomDimensions = /*#__PURE__*/function (GTMCustomDimensions) {
  GTMCustomDimensions["ENVIRONMENT"] = "environment";
  GTMCustomDimensions["COUNTRY"] = "country";
  GTMCustomDimensions["TENANT"] = "tenant";
  GTMCustomDimensions["LEGACY"] = "legacy";
  GTMCustomDimensions["PAGE_TYPE"] = "pageType";
  GTMCustomDimensions["PAGE_TITLE"] = "pageTitle";
  GTMCustomDimensions["PAGE_URL"] = "pageUrl";
  GTMCustomDimensions["PAGE_PATH"] = "pagePath";
  GTMCustomDimensions["PAGE_SEARCH_KEYWORD"] = "pageSearchKeyword";
  GTMCustomDimensions["PAGE_SEARCH_RESULTS"] = "pageSearchResults";
  GTMCustomDimensions["USER_LOGGED_IN"] = "userLoggedIn";
  GTMCustomDimensions["USER_MARKETPLACE"] = "userMarketplace";
  GTMCustomDimensions["MARKETPLACE_INTEGRATED"] = "marketplaceIntegrated";
  GTMCustomDimensions["CRM_SEGMENT_USER"] = "CRMSegment";
  GTMCustomDimensions["CRM_SEGMENT_SESSION"] = "CRMSegment";
  GTMCustomDimensions["CRM_SEGMENT_HIT"] = "CRMSegment";
  GTMCustomDimensions["USER_ID_SESSION"] = "userId";
  GTMCustomDimensions["USER_ACQUISITION_DATE"] = "userAcquisitionDate";
  GTMCustomDimensions["USER_SIZE"] = "userSize";
  GTMCustomDimensions["CAMPAIGN_TRACKING"] = "campaignTracking";
  GTMCustomDimensions["EMAIL_ENHANCED_CONVERSIONS"] = "emailEnhancedConversions";
  GTMCustomDimensions["CLIENT_ID"] = "clientId";
  GTMCustomDimensions["COUNTRY_FROM"] = "countryFrom";
  GTMCustomDimensions["COUNTRY_TO"] = "countryTo";
  GTMCustomDimensions["POSTAL_CODE_FROM"] = "postalCodeFrom";
  GTMCustomDimensions["POSTAL_CODE_TO"] = "postalCodeTo";
  GTMCustomDimensions["UPSELLS"] = "upsells";
  GTMCustomDimensions["LOCATION_TYPE"] = "locationType";
  GTMCustomDimensions["PARCELS_COUNT"] = "parcelsCount";
  GTMCustomDimensions["PARCELS_WEIGHT"] = "parcelsWeight";
  GTMCustomDimensions["FIRST_PURCHASE_INTEGRATED"] = "firstPurchaseIntegrated";
  GTMCustomDimensions["SIGN_UP_DETAIL_MONTHLY_SHIPMENTS"] = "signUpDetail_monthlyShipments";
  GTMCustomDimensions["SIGN_UP_DETAIL_ECOMMERCE_RELATED"] = "signUpDetail_e-commerceRelated";
  GTMCustomDimensions["SIGN_UP_DETAIL_ECOMMERCE_RELATED_NAME"] = "signUpDetail_e-commerceRelatedName";
  GTMCustomDimensions["SIGN_UP_DETAIL_ECOMMERCE_MAIN_MARKETPLACE"] = "signUpDetail_e-commerceMainMarketplace";
  GTMCustomDimensions["FEATURE_FLAGS"] = "featureFlags";
  return GTMCustomDimensions;
}({});
let GTMEEDimensions = /*#__PURE__*/function (GTMEEDimensions) {
  GTMEEDimensions["NAME"] = "name";
  GTMEEDimensions["ID"] = "id";
  GTMEEDimensions["URL"] = "url";
  GTMEEDimensions["BRAND"] = "brand";
  GTMEEDimensions["CATEGORY"] = "category";
  GTMEEDimensions["CATEGORY1"] = "category1";
  GTMEEDimensions["CATEGORY2"] = "category2";
  GTMEEDimensions["CATEGORY3"] = "category3";
  GTMEEDimensions["CATEGORY4"] = "category4";
  GTMEEDimensions["VARIANT"] = "variant";
  GTMEEDimensions["CURRENCY"] = "currency";
  GTMEEDimensions["PRICE"] = "price";
  GTMEEDimensions["TAX"] = "tax";
  GTMEEDimensions["QUANTITY"] = "quantity";
  GTMEEDimensions["COUNTRY_FROM"] = "dimension21";
  GTMEEDimensions["COUNTRY_TO"] = "dimension22";
  GTMEEDimensions["POSTAL_CODE_FROM"] = "dimension23";
  GTMEEDimensions["POSTAL_CODE_TO"] = "dimension24";
  GTMEEDimensions["UPSELLS"] = "dimension25";
  GTMEEDimensions["LOCATION_TYPE"] = "dimension26";
  GTMEEDimensions["PARCELS_COUNT"] = "dimension27";
  GTMEEDimensions["PARCELS_WEIGHT"] = "dimension28";
  GTMEEDimensions["LIST"] = "list";
  GTMEEDimensions["POSITION"] = "position";
  return GTMEEDimensions;
}({});
let GTMActionFieldList = /*#__PURE__*/function (GTMActionFieldList) {
  GTMActionFieldList["EDIT_SERVICE_FROM_SIDEPANEL"] = "Edit service from sidepanel";
  GTMActionFieldList["SERVICE_SELECT_PRO"] = "Service Selection pro";
  GTMActionFieldList["SERVICE_SELECT_COM"] = "Service Selection com";
  GTMActionFieldList["PRODUCT_INSURANCE"] = "Product Insurance";
  return GTMActionFieldList;
}({});
let GTMActions = /*#__PURE__*/function (GTMActions) {
  GTMActions["FORM_START"] = "Form Start";
  GTMActions["FORM_FIELD_ENTERED"] = "Form Field Entered";
  GTMActions["FORM_SUBMIT"] = "Form Submit";
  GTMActions["FORM_SUBMIT_SUCCESSFUL"] = "Form Submit Successful";
  GTMActions["AUTO_LOGIN"] = "autoLogin";
  GTMActions["INTEGRATION_COMPLETED"] = "Integration Completed";
  GTMActions["AUTOMATIC_IMPORT"] = "Automatic Import";
  GTMActions["COPY_API_KEY"] = "Copy API Key";
  GTMActions["PRODUCT_IMPRESSION"] = "Product Impression";
  GTMActions["PRODUCT_CLICK"] = "Product Click";
  GTMActions["PRODUCT_DETAILS"] = "Product Details";
  GTMActions["ADD_TO_CART"] = "Add To Cart";
  GTMActions["REMOVE_FROM_CART"] = "Remove From Cart";
  GTMActions["CHECKOUT_STEP"] = "Checkout - ";
  GTMActions["PURCHASE"] = "Purchase";
  GTMActions["CONFIRM_PURCHASE"] = "Confirm Purchase";
  GTMActions["REFUND"] = "Refund";
  return GTMActions;
}({});
let GTMPageType = /*#__PURE__*/function (GTMPageType) {
  GTMPageType["PUBLIC_KOKUDO"] = "Public | Public.kokudo";
  GTMPageType["COM"] = "Com";
  GTMPageType["SIGN_IN_PRO"] = "Sign-in Pro";
  GTMPageType["SIGN_UP_PRO"] = "Sign-up Pro";
  GTMPageType["TABLE_PRO"] = "Table Pro";
  GTMPageType["MARKETPLACE_CONNECT_PROCESS_PRO"] = "Marketplace Connect process Pro";
  GTMPageType["SEARCH_SHIPPING_PRO"] = "Search Shipping Pro ";
  GTMPageType["PLP_COM"] = "PLP Com";
  GTMPageType["PLP_PRO"] = "PLP Pro";
  GTMPageType["PDP_COM"] = "PDP Com";
  GTMPageType["PDP_PRO"] = "PDP Pro";
  GTMPageType["CHECKOUT_COM"] = "Checkout Com";
  GTMPageType["CHECKOUT_PRO"] = "Checkout Pro";
  GTMPageType["TRANSACTION_COM"] = "Transaction Com";
  GTMPageType["TRANSACTION_PRO"] = "Transaction PRO";
  return GTMPageType;
}({});
let GTMTypeOfServices = /*#__PURE__*/function (GTMTypeOfServices) {
  GTMTypeOfServices["PICK_UP"] = "pickup";
  GTMTypeOfServices["DROP_OFF"] = "dropoff";
  GTMTypeOfServices["COLLECTION"] = "collection";
  GTMTypeOfServices["DELIVERY"] = "delivery";
  return GTMTypeOfServices;
}({});
let GTMCrmSegment = /*#__PURE__*/function (GTMCrmSegment) {
  GTMCrmSegment["NEVER_BUYER"] = "NB";
  GTMCrmSegment["FIRST_TIME_BUYER"] = "FTB";
  GTMCrmSegment["RETURNING_BUYER"] = "RB";
  return GTMCrmSegment;
}({});
let GTMShipmentCategory = /*#__PURE__*/function (GTMShipmentCategory) {
  GTMShipmentCategory["NATIONAL"] = "National";
  GTMShipmentCategory["CONTINENTAL"] = "Continental";
  GTMShipmentCategory["INTERNATIONAL"] = "International";
  return GTMShipmentCategory;
}({});
let GTMShipmentSource = /*#__PURE__*/function (GTMShipmentSource) {
  GTMShipmentSource["MANUAL"] = "manual";
  GTMShipmentSource["TECH_ECOMMERCE"] = "tech-";
  GTMShipmentSource["CSV"] = ".csv";
  return GTMShipmentSource;
}({});

export { GTMActionFieldList, GTMActions, GTMCrmSegment, GTMCustomDimensions, GTMEEDimensions, GTMEvents, GTMPageType, GTMShipmentCategory, GTMShipmentSource, GTMTypeOfServices, UpsellInsuranceType };
//# sourceMappingURL=gtm.js.map
